import React from 'react';

type Props = {
  rotate: number;
  stroke: string;
  width: string | number;
  height: string | number;
  strokeWidth: string | number;
};

const ArrowUpIcon: React.FC<Partial<Props>> = ({
  rotate = 0,
  height = '6',
  width = '10',
  stroke = '#E6E6E6',
  strokeWidth = '1.5'
}) => (
  <svg
    width={width}
    height={height}
    className="duration-200 ease-in-out"
    style={{
      transform: `rotate(${rotate}deg)`
    }}
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.47498 8.95986L4.73498 5.69986C5.11998 5.31486 5.11998 4.68486 4.73498 4.29986L1.47498 1.03986"
      stroke={stroke}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
    />
  </svg>
);

export default ArrowUpIcon;
